import React from 'react';
import { get, size, has, map, includes } from 'lodash';
import moment from 'moment';
import { string, func, object } from 'prop-types';
import { Row, Loading, Accordion, Text, If, FlexContainer, NotFound, Button } from '../../common';
import UIStatusTable from '../../sections/Resume/UIStatusTable';
import GetAuditHistory from '../../graphql/getAuditHistory';
import { getColumns } from './AuditOrderTableHistory';
import AuditHeaderInfo from './AuditHeaderInfo';

const { excessColumns, substituteColumns, parentColumns } = getColumns();

const TitleComponent = ({ createdBy, user, createdAt }) => {
    const TextComponent = ({ text }) => (
        <Text
            text={text}
            style={{ minWidth: '120px' }}
            strong
            size={16}
        />
    );

    TextComponent.propTypes = {
        text: string
    };

    return (
        <Row align='center'>
            <If
                condition={has(user, 'email')}
                then={<TextComponent text={`${get(user, 'firstName')} ${get(user, 'lastName')}`} />}
                else={<TextComponent text={createdBy} />}
            />
            <div style={{ width: '1px', border: '1px solid #eaeaea', margin: '0px 10px', height: '20px' }} />
            <Text text={moment(createdAt).format('DD/MM/YYYY HH:mm')} />
        </Row>
    );
};

TitleComponent.propTypes = {
    createdBy: string,
    user: object,
    createdAt: string
};

class AuditHistory extends React.Component {
    _renderTableItem = ({ auditInfo, items }, columns) => (_item, index) => {
        const { orderId } = this.props;
        const item = { ...get(items, get(_item, 'productId'), {}), auditItemResults: _item };
        const status = get(item, 'picking.status');
        const parentProps = { orderId, auditInfo }; // used to pass parent to atributes to children
        const hasExcess = has(item, 'picking.excess') && get(item, 'picking.excess') !== 0;
        // creates a children array from every substitution entry
        const children = map(get(item, 'picking.substitution', []), (childrenItem) => {
            return {
                ...childrenItem,
                picking: { status: String(status).toLowerCase() },
                type: String(status).toLowerCase()
            };
        });

        const hasChildren = size(children);

        const _drawRowBorderBottom = (has, index, siz) => {
            if ((index === siz) && (has === false)) return '1px solid #eaeaea';
            if (has === 0) return '1px solid #eaeaea';
            if (has) return '1px dashed #eaeaea';
            return '1px solid transparent';
        };

        const buildRow = (tds, { width, ...item }, index, prefix = 'item', hasChildren, style = {}, childStyle = {}) => {
        const id = String(get(item, 'picking.productId', `${prefix}-${index}`));
            return (
                <tr key={`${prefix}-item-${id}`} style={style}>
                    { tds.map(({ dataIndex, columnStyle = {}, render = () => (null) }, key) => (
                        <td
                            key={`${prefix}-item-${id}-child-${key}`}
                            style={{
                                borderBottom: _drawRowBorderBottom(hasChildren, index + 1, size(children)),
                                padding: 10,
                                fontSize: '11px',
                                maxWidth: '210px',
                                textAlign: 'right',
                                ...columnStyle,
                                ...childStyle
                            }}
                        >
                            { render({ ...item }, dataIndex, parentProps) }
                        </td>
                    ))}
                </tr>
            );
        };

        const row = [item].map((item, index) => buildRow(get(columns, 'parentColumns', []), item, index, 'parent', hasChildren))

        const tableChunk = [
            ...row,
            hasChildren ? children.map((item, index) => buildRow(get(columns, 'subsColumns', []), item, index, 'children', false)) : [],
            hasExcess ? buildRow(get(columns, 'excessColumns', []), item, index, 'excess', false, { backgroundColor: ' #f4f4f4' }, { padding: '3px 10px' }) : []
        ];

        return tableChunk;
    };

    _renderTableHeader = ({ title, width }, key) => (
        <th className='' key={`th-${key}`} style={{ width, fontSize: '12px' }} >{title}</th>
    );

    _getHeaderLabels = (columns) => columns.map(({ title, width }) => ({ title, width }));

    _getAuditedItems = ({ auditInfo, items }) => get(auditInfo, 'results.results.audited', []);

    render () {
        const { orderId, onClose } = this.props;
        return (
            <FlexContainer direction='column' flex={1}>
                <FlexContainer flex={1} grow={0} direction='column'>
                    <GetAuditHistory orderId={orderId}>
                        {({ loading, data }) => (
                            <Loading loading={loading}>
                                <If
                                    condition={size(get(data, 'auditHistory')) <= 0}
                                    then={
                                        <FlexContainer justify='center' style={{ minHeight: 'calc(90vh - 55px)' }}>
                                            <NotFound
                                                firstTextLine='Este pedido no tiene auditorías'
                                                childButton={
                                                    <Button text='cerrar' width={76} onClick={() => onClose()} />
                                                }
                                            />
                                        </FlexContainer>
                                    }
                                    else={
                                        <>
                                            <FlexContainer direction='column'>
                                                <AuditHeaderInfo orderId={orderId}  showWeightValidation={true}/>
                                            </FlexContainer>
                                            { map(get(data, 'auditHistory'), ({ weightError, ...auditInfo }, index) => (
                                                <FlexContainer mY={10} direction='column' key={index}>
                                                    <Accordion
                                                        title={<TitleComponent {...auditInfo} />}
                                                        background='white'
                                                        closedBackground='white'
                                                        defaultOpened={false}
                                                    >
                                                        <Row>
                                                            <UIStatusTable
                                                                className='default-table'
                                                                style={{ margin: 0 }}
                                                                tableProps={{ className: 'order-items-table' }}
                                                                renderItem={
                                                                    this._renderTableItem({ auditInfo: get(auditInfo, 'audits.audited'), items: get(auditInfo, 'picking') }, {
                                                                        parentColumns: parentColumns,
                                                                        subsColumns: substituteColumns,
                                                                        excessColumns: excessColumns
                                                                    })
                                                                }
                                                                renderHeader={this._renderTableHeader}
                                                                headers={this._getHeaderLabels(parentColumns)}
                                                                data={get(auditInfo, 'audits.audited')}
                                                            />
                                                        </Row>
                                                    </Accordion>
                                                </FlexContainer>
                                            ))}
                                        </>
                                    }
                                />
                            </Loading>
                        )}
                    </GetAuditHistory>
                </FlexContainer>
            </FlexContainer>

        );
    }
};

AuditHistory.propTypes = {
  orderId: string,
  onClose: func
};

export default AuditHistory;
